import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const productsJcsFormFieldsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-products-jcs-form-fields" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
